<footer class="footer">

  <div class="footer-container">

    <!-- ==========================================
         PARTE SUPERIOR
    =========================================== -->
    <div class="footer-top">


      <!-- LOGO TC BROKERS -->
      <div class="footer-brand">

        <img
          src="assets/images/logo.svg"
          alt="TC Brokers"
          class="footer-logo"
        />

        <p>
          Protegemos lo que te mueve.
        </p>

      </div>


      <!-- APS -->
      <div class="footer-aps">

        <img
          src="assets/icons/aps-logo.png"
          alt="APS"
          class="aps-logo"
        />

        <p>
          Este operador está bajo la fiscalización y control de la
          Autoridad de Fiscalización y Control de Pensiones y Seguros - APS
        </p>

      </div>


      <!-- CONTACTO -->
      <div class="footer-contact">

        <a
          href="tel:+591800101727"
          class="contact-phone"
        >

          <i class="icon-smartphone-call"></i>

          <span>
            +591 800 10 1727
          </span>

        </a>


        <a
          href="https://wa.me/591800101727"
          target="_blank"
          rel="noopener noreferrer"
          class="contact-whatsapp"
        >

          <span>
            WhatsApp
          </span>

          <span class="contact-arrow">
            ↗
          </span>

        </a>

      </div>

    </div>


    <!-- ==========================================
         LINEA DIVISORIA
    =========================================== -->
    <div class="footer-divider"></div>


    <!-- ==========================================
         PARTE INFERIOR
    =========================================== -->
    <div class="footer-bottom">


      <!-- COPYRIGHT -->
      <div class="footer-copy">

        © {{ currentYear }} TC Brokers copyright.

      </div>


      <!-- DERECHOS -->
      <div class="footer-rights">

        Todos los derechos reservados.

      </div>


      <!-- LEGALES + REDES -->
      <div class="footer-actions">


        <div class="footer-legal">

          <a href="#">
            Privacidad
          </a>

          <span>
            ·
          </span>

          <a href="#">
            Términos
          </a>

        </div>


        <!-- REDES SOCIALES -->
        <div class="footer-social">


          <a
            href="#"
            aria-label="Facebook"
            class="social-button"
          >
            <i class="icon-facebook"></i>
          </a>


          <a
            href="#"
            aria-label="Instagram"
            class="social-button"
          >
            <i class="icon-instagram"></i>
          </a>


          <a
            href="#"
            aria-label="LinkedIn"
            class="social-button"
          >
            <i class="icon-linkedin"></i>
          </a>


        </div>

      </div>

    </div>

  </div>

</footer>